export default __webpack_public_path__ + "static/media/0xdc9232e2df177d7a12fdff6ecbab114e2231198d.0fa6cebb.svg";